import React from "react";
import { ShieldCheck } from "lucide-react";
import { useLang } from "../lib/i18n";

const CARDS = [
  { icon: "fa-cc-visa", color: "#1a1f71", label: "Visa" },
  { icon: "fa-cc-mastercard", color: "#eb001b", label: "Mastercard" },
  { icon: "fa-cc-amex", color: "#2e77bc", label: "American Express" },
  { icon: "fa-cc-paypal", color: "#003087", label: "PayPal" },
];

export function PaymentBadges() {
  const { t } = useLang();
  return (
    <div data-testid="payment-badges" className="flex flex-col items-center gap-1.5 pt-1">
      <div className="flex items-center gap-1.5 text-xs font-semibold text-slate-500">
        <ShieldCheck className="h-3.5 w-3.5 text-emerald-600" />
        {t("secure_payment")}
      </div>
      <div className="flex items-center gap-3">
        {CARDS.map((c) => (
          <i key={c.label} aria-label={c.label} title={c.label} data-testid={`badge-${c.icon}`}
             className={`fa-brands ${c.icon} text-3xl leading-none`} style={{ color: c.color }} />
        ))}
      </div>
    </div>
  );
}
